import {
  Cancel as CancelIcon,
  CheckCircle as CheckCircleIcon,
  Description as DescriptionIcon,
  Notifications as NotificationsIcon,
  Pending as PendingIcon,
  Schedule as ScheduleIcon,
} from "@mui/icons-material";
import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  statusAutorizacaoEnum,
  statusAutorizacaoLabels,
} from "../utils/constants";
import { getAutorizacaoPaletteKey } from "../utils/statusPalette";
import { getStatusChipSx } from "./StatusChip";

const statusIconMap = {
  [statusAutorizacaoEnum.AGUARDANDO_ANALISE]: ScheduleIcon,
  [statusAutorizacaoEnum.EM_ANALISE]: PendingIcon,
  [statusAutorizacaoEnum.SOLICITANDO_INFORMACOES]: NotificationsIcon,
  [statusAutorizacaoEnum.APROVADA]: CheckCircleIcon,
  [statusAutorizacaoEnum.REJEITADA]: CancelIcon,
  [statusAutorizacaoEnum.EMITIDA]: DescriptionIcon,
};

function AutorizacaoStatusChip({ status }) {
  const theme = useTheme();
  const paletteKey = getAutorizacaoPaletteKey(status);
  const label = statusAutorizacaoLabels[status] ?? status;
  const IconComponent = statusIconMap[status] ?? PendingIcon;
  const chipSx = getStatusChipSx(theme, paletteKey);

  return (
    <Chip
      icon={<IconComponent />}
      label={label}
      size="small"
      sx={chipSx}
    />
  );
}

export default AutorizacaoStatusChip;
